import OverviewPage from 'components/admin/OverviewPage.vue';

const adminDevelopmentRoutes = [
    {
        name: 'dev-apiv2',
        path: 'development/apiv2',
        component: () => import('pages/sot.bot.admin/dev/apiv2/Apiv2Index.vue'),
        children: [
            {
                name: 'dev-apiv2-tab',
                path: ':tab',
                component: () => import('pages/sot.bot.admin/dev/apiv2/Apiv2Index.vue'),
            },
        ],
    },
    {
        name: 'dev-components',
        path: 'development/components',
        component: () => import('pages/sot.bot.admin/dev/components/ComponentsIndex.vue'),
        children: [
            {
                name: 'dev-components-tab',
                path: ':tab',
                component: () => import('pages/sot.bot.admin/dev/components/ComponentsIndex.vue'),
            },
        ],
    },
    {
        name: 'ui-kit-overview',
        path: 'development/ui-kit',
        component: OverviewPage,
    },
    {
        name: 'dev-ui-kit-section',
        path: 'development/ui-kit/:section',
        component: () => import('pages/sot.bot.admin/dev/ui-kit/UiKitIndex.vue'),
    },
    {
        name: 'dev-ui-kit-tab',
        path: 'development/ui-kit/:section/:tab',
        component: () => import('pages/sot.bot.admin/dev/ui-kit/UiKitIndex.vue'),
    },
    { path: 'development/api-queries', component: () => import('pages/sot.bot.admin/api-queries/ApiIndex.vue') },
];

export default adminDevelopmentRoutes;
